import { render, staticRenderFns } from "./vizeraporu.vue?vue&type=template&id=227d46b8&"
import script from "./vizeraporu.vue?vue&type=script&lang=js&"
export * from "./vizeraporu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports